import routerOptions0 from "/codebuild/output/src116989847/src/toppan-voice-recorder-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}